module.exports = __webpack_public_path__ + "media/customizations/serenbe/logo-df6ddabaf567259b76c4436057328dfe.png";